// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/font/font.css'

Vue.config.productionTip = false

/* 监听路由变化
 */
router.beforeEach((to, from, next) => {
  if (to.matched && to.matched.length == 0) {
    router.replace({
      name: 'NotFind'
    });
    return;
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js